import type { TechnologyCardProps } from "@components/TechnologyCardProps.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import cloud from "@core/assets/icons/cloud.svg?raw";
import code from "@core/assets/icons/code.svg?raw";
import db from "@core/assets/icons/db.svg?raw";
import git from "@core/assets/icons/git.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";

export function getTechnologiesMobileApps(tenant: Tenant): TechnologyCardProps[] {
	return [
		{
			title: "Jazyky",
			iconName: brackets,
			items: ["Svelte", "Angular", "React", "Vue", "Node.js", "TypeScript"],
		},
		{
			title: "Kódování ",
			iconName: code,
			items: ["React Native", "Ionic", "Flutter", "Tailwind", "SCSS/SASS"],
		},
		{
			title: "Repozitář",
			iconName: git,
			items: ["GitLab", "GitHub", "BitBucket"],
		},
		{
			title: "Databáze",
			iconName: db,
			items: ["PostgresSQL", "DynamoDB", "MongoDB"],
		},
		{
			title: "Cloud",
			iconName: cloud,
			items: ["AWS", "GCP", "Linux", "Azure"],
		},
	];
}
